import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NETWORK } from '@arianee/arianeejs';
import { NavController } from '@ionic/angular';
import moment from 'moment/moment';
import { Subscription } from 'rxjs';

import { EventLoggerService } from '../../../../../providers/event-logger/event-logger-service';
import { NotificationService } from '../../../../../providers/notification-service/notification.service';
import { EnrichedNotificationNetwork } from '../../models/enriched-notification-network.model';

@Component({
	selector: 'app-notifications-legacy',
	templateUrl: './notifications-legacy.component.html',
	styleUrls: ['./notifications-legacy.component.scss'],
})
export class NotificationsLegacyComponent implements OnInit, OnDestroy {
	@ViewChild('messagesContent', { static: false }) messagesContent;

	messages: Array<{
		name: string;
		avatarurl: string;
		latestmessage: Object;
		status: number;
	}> = [];

	notifications: Array<EnrichedNotificationNetwork> = [];
	private subscriptions: Array<Subscription> = [];

	constructor(
		private navCtrl: NavController,
		private eventLogger: EventLoggerService,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.eventLogger.logScreen('notif', {});
		const sub = this.notificationService.$notifications.subscribe((notifs) => {
			this.notifications = notifs.sort((left, right) =>
				moment(right.time).diff(moment(left.time)),
			);
		});
		this.subscriptions.push(sub);
	}

	onNotificationClick(
		certificateId: string,
		isRead: boolean,
		messageId: string,
		network: NETWORK,
	) {
		this.navCtrl.navigateForward(`/notification/${network}/${certificateId}`, {
			queryParams: { isRead: isRead, messageId: messageId },
		});
	}

	onClickStartChat(index) {
		this.navCtrl.navigateForward('/chat');
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
